"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ORDERS_APP_ID = "13e8d036-5516-6104-b456-c8466db39542";
var MENUS_APP_ID = "13c1402c-27f2-d4ab-7463-ee7c89e07578";
var KIT_APP_ID = "14583ff5-e781-063a-3bc4-6b79fb966992";
var SEATING_APP_ID = "1475ab65-206b-d79a-856d-fa10bdb479ea";
var ORDERS_DEV_APP_ID = "13a2d835-34bd-a50b-c634-c9158ba38c0d";

var instance = null;
var codedInstance = null;
var appId = null;

exports.default = {
    init: function init(_instance, _appId) {

        // We can't validate signature since that will require the app secret. Since the server
        // checks all our request, it will validate the signature.

        try {
            appId = _appId;
            codedInstance = _instance;
            var instanceBase64 = _instance.substr(_instance.indexOf(".") + 1);
            var instanceJson = atob(instanceBase64);
            instance = JSON.parse(instanceJson);
        } catch (e) {
            codedInstance = null;
            instance = null;
            throw "Invalid Instance";
        }
    },
    getAppId: function getAppId() {
        return appId;
    },
    getInstance: function getInstance() {
        if (!codedInstance) return null;
        return codedInstance;
    },
    getParsedInstance: function getParsedInstance() {
        return instance;
    },
    getMetasiteId: function getMetasiteId() {
        if (!instance) return null;
        return instance.msid;
    },
    getMetasiteIdCalculate: function getMetasiteIdCalculate() {
        var parsedInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : instance;

        var str = parsedInstance.biToken;
        var key = parsedInstance.instanceId;

        var keys = key.split('');
        return str.split('').map(function (s, i) {
            var a = parseInt(s, 16),
                b = parseInt(keys[i], 16);
            if (isNaN(a) || isNaN(b)) return s;else return (a ^ b).toString(16);
        }).join('');
    },

    getInstanceId: function getInstanceId() {
        if (!instance) return null;
        return instance.instanceId;
    },
    getOriginInstanceId: function getOriginInstanceId() {
        if (!instance) return null;
        return instance.originInstanceId;
    },
    getBiToken: function getBiToken() {
        if (!instance) return null;
        return instance.biToken;
    },
    getSiteOwnerId: function getSiteOwnerId() {
        if (!instance) return null;
        return instance.siteOwnerId;
    },
    getIsDemo: function getIsDemo() {
        if (!instance) return false;
        return instance.demoMode;
    },
    getPermissions: function getPermissions() {
        if (!instance) return null;

        // Simulating permissions because they are not implemented correctly in Wix due to
        // backwards compatability
        if (!instance.uid) return null;
        if (!instance.siteOwnerId) return null;

        if (instance.uid === instance.siteOwnerId) {
            return "owner";
        } else if (instance.uid) {
            return "contributor";
        } else {
            return null;
        }
    },
    getUserId: function getUserId() {
        if (!instance) return null;
        return instance.uid;
    },
    getAnonymousUserId: function getAnonymousUserId() {
        if (!instance) return null;
        return instance.aid;
    },
    getVisitorId: function getVisitorId() {
        if (!instance) return null;
        return instance.uid || instance.aid;
    },
    isValidSession: function isValidSession() {
        return codedInstance !== null;
    },
    getVendorProductId: function getVendorProductId() {
        if (!instance.vendorProductId) return null;
        return instance.vendorProductId;
    },

    ORDERS_APP_ID: ORDERS_APP_ID,
    MENUS_APP_ID: MENUS_APP_ID,
    KIT_APP_ID: KIT_APP_ID,
    SEATING_APP_ID: SEATING_APP_ID,
    ORDERS_DEV_APP_ID: ORDERS_DEV_APP_ID,

    getAllAppIds: function getAllAppIds() {
        return [ORDERS_APP_ID, MENUS_APP_ID, KIT_APP_ID, SEATING_APP_ID, ORDERS_DEV_APP_ID];
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/WixInstance.js
// module id = 116
// module chunks = 0